module.exports = {
      id: "user-square-usage",
      viewBox: "0 0 18 18",
      url: "/" + "sprite-bc0169963456b1a4ad1bb8f1c406f483.svg#user-square",
      toString: function () {
        return this.url;
      }
    }